import * as qs from 'qs';

import { get } from '../../../redux/api';
import type {
  FeaturesResponse,
  PortalHeader,
  ReleaseGroupReleasesResponse,
  ReleaseGroupsResponse,
} from '../../../../shared/publicPortal/types';

export const getPortalHeader = async (slug: string) => get<PortalHeader>(`/api/organization-portals/${slug}/header`);

export const getReleaseGroups = async ({
  slug,
  search,
  isPublic,
}: {
  slug: string;
  isPublic: boolean;
  search?: string;
}) => {
  const qParams = qs.stringify({ search, isPublic });
  return get<ReleaseGroupsResponse>(`/api/organization-portals/${slug}/release-groups?${qParams}`);
};

export const getReleaseGroupReleases = async (slug: string, releaseGroupId: number) =>
  get<ReleaseGroupReleasesResponse>(`/api/organization-portals/${slug}/release-groups/${releaseGroupId}`);

export const getPortalFeatures = async (slug: string) =>
  get<FeaturesResponse>(`/api/organization-portals/${slug}/features`);

export const getPortalId = async (slug: string) => get<{ id: number }>(`/api/organization-portals/${slug}/id`);
